const translations = {
    en: {
        loginTitle: "Login",
        selectUser: "Select Login User",
        admin: "Admin",
        superAdmin: "Super Admin",
        mobileNumber: "Mobile Number",
        password: "*********",
        enterPassword: "Enter Password",
        rePassword: "Re-Enter Password",
        rememberMe: "Remember Me",
        forgotPassword: "Forgot Password?",
        loginButton: "Login",
        orLoginWith: "Or login with",
        google: "Google",
        apple: "Apple",
        dontHaveAccount: "Don't have an account?",
        signUp: "Sign Up",
        enterYourNumberToRecieveACode: "Enter your phone number to receive a code for resetting your password.",
        gender: "Gender",
        male: "Male",
        female: "Female",
        firstName: "First Name",
        middleName: "Middle Name",
        lastName: "Last Name",
        verify: "Verify",
        email: "Email",
        twoStepVerification: "Two Step Verification",
        otpVerifyText: " For added security, please enter the One Time Password (OTP) that has been sent to mobile number.",
        verification: "Verification",
        pleaseWait: "Please wait for",
        seconds: "seconds",
        didntReceiveCode: "Didn't receive code?",
        resendCode: "Resend Code",
        getOtp: "Get OTP",
        createPassword: "Create New Password",
        passwordValidation: "New password must include at least one:",
        includesCharacters: "Includes 8-16 characters",
        includesNumber: "Number",
        includesSpecialChar: "Special character",
        includesLowercase: "Lowercase letter",
        includesUppercase: "Uppercase letter",
        welcome: "Welcome",
        welcomeDescription: "To become a leading center of excellence for research, training, and data analysis on climate change and development in Africa.",
        niccrra: "NICCRRA.",
        allCopyRightReserved: "All Rights Reserved.",

        // user profile 
        profile: "Profile",
        changePassword: "Change Password",
        logout: "Log out",
        editProfile: "Edit Profile",
        updateProfile: "Update Profile",

        // Side Menu Items
        dashboard: "Dashboard",
        farmers: "Farmers",
        taskAssignment: "Task Assignment",
        dataCollectors: "Data Collectors",
        reportSubmission: "Report Submission",
        userManagement: "User Management",
        regionAndLocality: "Region & Locality",
        typeOfCrops: "Type Of Crops",
        typeOfLivestock: "Type Of Livestock",
        typeOfPisciculture: "Type of Pisciculture",
        typeOfMachinery: "Type Of Machinery",
        certificationsAndTraining: "Certifications & Training",
        trainingProgram: "Training Program",
        whoSponsored: "Who Sponsored",

        // Dashboard Cards
        totalFarmersRegistered: "TOTAL Farmers Registered",
        pendingFarmerApprovals: "PENDING Farmer Approvals",
        taskAssignmentNotifications: "TASK Assignment Notifications",
        totalDataCollectors: "TOTAL Data Collectors",

        // Dashboard 
        performanceMetricsOfDataCollectors: "Performance Metrics Of Data Collectors",
        today: "Today",
        thisWeek: "This Week",
        thisMonth: "This Month",

        // Farmers 
        farmersList: "Farmers List",
        srNo: "Sr. No",
        photo: "Photo",
        farmerName: "Farmer Name",
        date: "Date",
        dataCollectorName: "Data Collector Name",
        mobileNo: "Mobile No.",
        location: "Location",
        statusView: "Status/View",
        clear: "Clear",
        selectStatus: "Select Status",
        approved: "Approved",
        pending: "Pending",
        reject: "Reject",
        selectTimePeriod: "Select Time Period",
        fromDate: "From Date",
        toDate: "To Date",
        today: "Today",
        week: "Week",
        month: "Month",
        year: "Year",
        selectLocation: "Select Location",
        selectFarmingCategory: "Select Farming Category",
        selectInfrastructureProximity: "Select Infrastructure Proximity",
        selectGender: "Select Gender",
        selectRegion: "Select Region",
        submit: "Submit",
        cancel: "Cancel",
        farmersDetailsView: "Farmers Details View",
        reject: "Reject",
        personalDetails: "Personal Details",
        locationDetails: "Location Details",
        farmingDetails: "Farming Details",
        farmOwnershipDetails: "Farm Ownership Details",
        accessToFinance: "Access to Finance",
        dateOfBirth: "Date of Birth",
        alternateMobileNumber: "Alternate Mobile Number",
        nationalIdentificationNo: "National Identification No.",
        address: "Address",
        latitude: "Latitude & Longitude",

        // Farming Details
        educationLevel: "Education Level",
        farmingExperience: "Farming Experience",
        typesOfCrops: "Types of Crops",
        cereals: "Cereals",
        legumes: "Legumes",
        rootsAndTubers: "Roots & Tubers",
        vegetables: "Vegetables",
        fruits: "Fruits",
        cashCrops: "Cash Crops",
        typesOfLivestock: "Types of Livestock",
        cattle: "Cattle",
        poultry: "Poultry",
        smallRuminants: "Small Ruminants",
        beefCattle: "Beef Cattle",
        chickens: "Chickens",
        goats: "Goats",

        // Farm Ownership Details
        farmOwnership: "Farm Ownership",
        owned: "Owned",
        titled: "Titled",
        leased: "Leased",
        untitled: "Untitled",
        infrastructureDetails: "Infrastructure Details",
        farmerHouse: "Farmer House",
        farmer: "Farmer",
        warehouse: "Warehouse",
        accessToRoadAndDistance: "Access to Road & Distance",
        available: "Available",
        notAvailable: "Not Available",
        processingPlants: "Processing Plants",
        typesOfMachinery: "Types of Machinery",
        tillageEquipment: "Tillage Equipment",
        industrial: "Industrial",
        mini: "Mini",
        handPush: "Hand Push",
        plows: "Plows",
        moldboard: "Moldboard",
        disc: "Disc",
        harrows: "Harrows",
        plantingEquipment: "Planting Equipment",
        speedDrills: "Seed Drills",
        planters: "Planters",
        transplanter: "Transplanter",
        rice: "Rice",
        vegetables: "Vegetables",

        // Access to Finance
        accessToFinance: "Access to Finance",
        loansFromGovernmentBank: "Loans from Government Bank",
        loansFromCommercialBank: "Loans from Commercial Bank",
        grantsFromINGOs: "Grants from iNGOs / Development Partner",
        emergencyContactDetails: "Emergency Contact Details",

        // Task Assignment
        taskAssign: "Task Assign",
        dataCollector: "Data Collector",
        description: "Description",
        region: "Region",
        state: "State",
        localGovernment: "Local Government",
        noOfFarmers: "Number of Farmers",
        deadline: "Deadline",
        completed: "Completed",
        filter: "Filter",
        selectDataCollector: "Select Data Collector",
        // Task Assignment Form
        enterTaskTitle: "Enter Task Title",
        taskDescription: "Task Description",
        selectState: "Select State",
        selectLocalGovernment: "Select Local Government",
        selectDataCollector: "Select Data Collector",
        enterNumberOfFarmers: "Enter Number Of Farmers",
        notification: "Notification:",
        assignTask: "Assign Task",


        // Task Details
        taskDetailsView: "Task Details View",
        status: "Status",
        sendReminder: "Send Reminder",
        farmersRegistered: "Farmers Registered",
        summary: "Summary",
        taskTitle: "Task Title",
        attachments: "Attachments",
        sendReminder: "Send Reminder",
        enterReminderTitle: "Enter Reminder Title",

        tasksReportSubmission: "Tasks Report Submission",
        yes: "Yes",
        no: "No",
        edit: "Edit",
        Update: "Update",
        delete: "Delete",


    },
    gu: {
        loginTitle: "લૉગિન",
        selectUser: "પ્રવેશ વપરાશકર્તા પસંદ કરો",
        admin: "એડમિન",
        superAdmin: "સુપર એડમિન",
        mobileNumber: "મોબાઇલ નંબર",
        password: "*********",
        rePassword: "પાસવર્ડ ફરીથી દાખલ કરો",
        rememberMe: "મને યાદ રાખો",
        forgotPassword: "પાસવર્ડ ભૂલી ગયા?",
        loginButton: "લૉગિન",
        orLoginWith: "અથવા સાથે લૉગિન કરો",
        google: "ગૂગલ",
        apple: "ઍપલ",
        dontHaveAccount: "એકાઉન્ટ નથી?",
        signUp: "સાઇન અપ",
        enterYourNumberToRecieveACode: "તમારો પાસવર્ડ રીસેટ કરવા માટે કોડ મેળવવા તમારો ફોન નંબર દાખલ કરો.",
        gender: "લિંગ",
        male: "પુરુષ",
        female: "સ્ત્રી",
        firstName: "પ્રથમ નામ",
        middleName: "મધ્યમ નામ",
        lastName: "અંતિમ નામ",
        verify: "ચકાસો",
        email: "ઇમેઇલ",
        twoStepVerification: "બે પગલાની ચકાસણી",
        pleaseWait: "કૃપા કરીને રાહ જુઓ",
        seconds: "સેકંડ",
        didntReceiveCode: "કોડ પ્રાપ્ત થયો નથી?",
        resendCode: "કોડ ફરીથી મોકલો",
        getOtp: "ઓટીપી મેળવો",
        createPassword: "નવો પાસવર્ડ બનાવો",
        passwordValidation: "નવા પાસવર્ડમાં ઓછામાં ઓછું એક હોવું જોઈએ:",
        includesCharacters: "8-16 અક્ષરો શામેલ છે",
        includesNumber: "આંકડો",
        includesSpecialChar: "વિશિષ્ટ અક્ષર",
        includesLowercase: "લોઅરકેસ અક્ષર",
        includesUppercase: "અપરકેસ અક્ષર",
        welcome: "સ્વાગત છે",
        welcomeDescription: "આફ્રિકામાં આબોહવા પરિવર્તન અને વિકાસ પર સંશોધન, તાલીમ અને ડેટા વિશ્લેષણ માટે શ્રેષ્ઠતા માટેનું અગ્રણી કેન્દ્ર બનવું.",
        niccrra: "NICCRRA.",
        allCopyRightReserved: "બધા હક્કો અનામત છે.",

        // user profile 
        profile: "પ્રોફાઇલ",
        changePassword: "પાસવર્ડ બદલો",
        logout: "લૉગ આઉટ",
        editProfile: "પ્રોફાઇલ સંપાદિત કરો",
        updateProfile: "પ્રોફાઇલ અપડેટ કરો",

        // Side Menu Items
        dashboard: "ડેશબોર્ડ",
        farmers: "ખેડૂતો",
        taskAssignment: "કાર્ય સોંપણી",
        dataCollectors: "ડેટા સંકલક",
        reportSubmission: "અહેવાલ રજૂઆત",
        userManagement: "વપરાશકર્તા વ્યવસ્થાપન",
        regionAndLocality: "પ્રદેશ અને સ્થાનિકતા",
        typeOfCrops: "વિભિન્ન પાક",
        typeOfLivestock: "વિભિન્ન પશુપાલન",
        typeOfPisciculture: "વિભિન્ન માછીમારી",
        typeOfMachinery: "વિભિન્ન યાંત્રિકતા",
        certificationsAndTraining: "પ્રમાણપત્ર અને તાલીમ",
        trainingProgram: "તાલીમ કાર્યક્રમ",
        whoSponsored: "યાર દ્વારા પ્રાયોજિત",

        // Dashboard Cards
        totalFarmersRegistered: "કુલ નોંધાયેલા ખેડૂતો",
        pendingFarmerApprovals: "બાકી ખેડૂત મંજૂરીઓ",
        taskAssignmentNotifications: "કાર્ય સોંપણી સૂચનાઓ",
        totalDataCollectors: "કુલ ડેટા સંકલક",

        // Dashboard 
        performanceMetricsOfDataCollectors: "ડેટા સંકલકના કાર્યક્ષમતા મેટ્રિક્સ",
        today: "આજે",
        thisWeek: "આ અઠવાડિયે",
        thisMonth: "આ મહિને",

        // Farmers


        // Farming Details
        educationLevel: "શિક્ષણ સ્તર",
        farmingExperience: "ખેત ખેડ અનુભવ",
        typesOfCrops: "પાકોના પ્રકારો",
        cereals: "અનાજ",
        legumes: "શીમ",
        rootsAndTubers: "મૂળો અને કંદમૂળ",
        vegetables: "શાકભાજી",
        fruits: "ફળ",
        cashCrops: "નગદી પાક",
        typesOfLivestock: "પશુપાલનના પ્રકારો",
        cattle: "ઢોર",
        poultry: "કુક્કુટ",
        smallRuminants: "નાના ચૂસણારા",
        beefCattle: "ગાય-ભેંસ",
        chickens: "મૂર્ગી",
        goats: "બકરા",

        // Farm Ownership Details
        farmOwnership: "ખેતર માલિકી",
        ownedTitled: "માલિકી: શીર્ષક",
        leasedUntitled: "કિરાયે: શીર્ષક વગર",
        infrastructureDetails: "મુળભૂત માળખાંની વિગતો",
        farmerHouse: "ખેડૂતનું ઘર",
        farmer: "ખેડૂત",
        warehouse: "ગોડાઉન",
        accessToRoadAndDistance: "રસ્તા અને અંતર માટેની ઍક્સેસ",
        available: "ઉપલબ્ધ",
        notAvailable: "ઉપલબ્ધ નથી",
        processingPlants: "પ્રક્રિયા પ્લાંટ",
        typesOfMachinery: "યાંત્રિક પ્રકારો",
        tillageEquipment: "ખેતી સાધનો",
        industrial: "ઔદ્યોગિક",
        mini: "મિની",
        handPush: "હેન્ડ પુશ",
        plows: "હળ",
        moldboard: "મોલ્ડબોર્ડ",
        disc: "ડિસ્ક",
        harrows: "હેરો",
        plantingEquipment: "પાક વાવેતર સાધનો",
        seedDrills: "બીજ ડ્રિલ્સ",
        planters: "પ્લાન્ટર્સ",
        transplanter: "ટ્રાન્સપ્લાન્ટર",
        rice: "ચોખા",
        vegetables: "શાકભાજી",

        // Access to Finance
        accessToFinance: "વિત્તિ સુધીની ઍક્સેસ",
        loansFromGovernmentBank: "સરકારી બેંકમાંથી લોન",
        loansFromCommercialBank: "વાણિજ્ય બેંકમાંથી લોન",
        grantsFromINGOs: "INGOs / વિકાસ ભાગીદાર પાસેથી ગ્રાન્ટ",

        // Emergency Contact Details
        emergencyContactDetails: "એમર્જન્સી સંપર્ક વિગતો",

        // Task Assignment Form
        enterTaskTitle: "કાર્ય શીર્ષક દાખલ કરો",
        taskDescription: "કાર્ય વર્ણન",
        selectRegion: "પ્રદેશ પસંદ કરો",
        selectState: "રાજ્ય પસંદ કરો",
        selectLocalGovernment: "સ્થાનિક સરકાર પસંદ કરો",
        selectDataCollector: "ડેટા સંકલક પસંદ કરો",
        enterNumberOfFarmers: "ખેડૂતોની સંખ્યા દાખલ કરો",
        deadline: "અંતિમ તારીખ",
        notification: "સૂચના",
        assignTask: "કાર્ય સોંપો",


    },
};

export default translations;
